export { UpmProductDetailTemplate } from './UpmProductDetailTemplate';
export * from './UpmProductDetailTemplate.types';
